const staffPageES = {
	services: {
		title: "Servicios",
		text: "servicios",
		add: "+ Agregar",
		empty: "No hay servicios aún.",
	},

	actions: {
		saveChanges: "Guardar cambios",
		cancel: "Cancelar",
	},

	sidebar: {
		location: {
			title: "Ubicación",
		},
		allStaff: "Todo el equipo",
		contact: {
			title: "Contacto",
			phone: "Teléfono",
			email: "Correo electrónico",
			noPhone: "Sin teléfono",
			noEmail: "Correo no disponible",
			socialTitle: "Redes sociales",
			website: "Sitio web",
			instagram: "Instagram",
			facebook: "Facebook",
			tiktok: "TikTok",
		},
		hours: {
			title: "Horario de apertura",
			show: "Mostrar más horarios",
			hide: "Ocultar horarios",
			closed: "Cerrado",
			edit: "Editar horario",
		},
		staff: {
			title: "Equipo",
			edit: "Gestionar equipo",
			roles: {
				admin: "Administrador",
				staff: "Empleado",
				owner: "Propietario",
			},
			noStaff: "No hay miembros en el equipo.",
			addStaff: "Invitar miembro",
			remove: "Eliminar",
			editRole: "Cambiar rol",
		},
	},

	modal: {
		shopInfo: {
			title: "Información del negocio",
			subTitle: "Detalles",
			name: "Nombre del negocio",
			description: "Descripción",
			address: "Dirección",
			city: "Ciudad",
			country: "País",
		},
		contact: {
			title: "Información de contacto",
			description: "Actualiza el teléfono, correo y redes sociales.",
		},
		hours: {
			title: "Horario comercial",
			description: "Configura los horarios de apertura y cierre por día.",
			open: "Abre",
			close: "Cierra",
			closed: "Cerrado",
		},
		team: {
			title: "Miembros del equipo",
			description: "Administra los miembros del equipo y sus roles.",
			addButton: "Invitar miembro",
			close: "Cerrar",
			save: "Guardar",
		},
	},

	book: "Reservar",
};

export default staffPageES;